import OriginalityDeviceContext from "../../tools/contexts/originalityDevice/originalityDeviceContext";
import {useLocation, useNavigate} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {divarLinkGenerator, safeRedirect} from "../../tools/helpers";
import Api from "../../tools/service";
import {Reoverlay} from "reoverlay";
import ErrorModal from "../../components/modals/ErrorModal";
import handleGenerateUuid from "../../tools/api/global/generateUuid";
import {OriginalityDeviceDefaultSteps} from "../../tools/defaults/originalityDevice/OriginalityDeviceDefaults";
import InitConfirm from "../../components/originalityDevice/InitConfirm";
import CreatePayment from "../../components/originalityDevice/CreatePayment";
import Final from "../../components/originalityDevice/Final";
import ProgressLoading from "../../components/loading/ProgressLoading";
import REQUEST_URLS from "../../tools/defaults/requestUrl";
import useDivarAuth from "../../hooks/useDivarAuth";
const OriginalityDevice = () => {
    const navigate = useNavigate();
    const {token,postToken,returnUrl,serviceType}=useDivarAuth();
    const [pid, setPid] = useState(null);
    const [isLoading, setIsLoading] = useState({
        showLoading: false,
        loadingText: 'لطفا منتظر بمانید',
    });
    const [process, setProcess] = useState();
    const [components, setComponents] = useState({
        current_component: {
            name: "InitConfirm"
        }
    });
    const [warning, setWarning] = useState(null)
    useEffect(() => {
        handleInquiryProcess()
    }, []);
    const handleRedirectToDivar = ({price, status}) => {
        const link = divarLinkGenerator({
            returnUrl,
            price,
            status,

        });
        safeRedirect(link,()=>{
            Reoverlay.showModal(ErrorModal,{
                title:'خطا',
                message:'لینک معتبر نمی باشد.',
                showCancelButton: true,
                cancelButtonText:'بستن',
                onCancel:()=>{
                    Reoverlay.hideModal();
                    navigate('/404')
                }
            })
        })
    }
    const handleProcess = (newProcess) => {
        setProcess(newProcess)
    }
    const handleLoading = (newLoading) => {
        setIsLoading(newLoading)
    }
    const handleUpdateStep = (newStep, passedStep) => {
        if (passedStep) {
            let passedSteps = [...process.passed_steps, passedStep];

            const newState = {
                ...process,
                current_step: newStep,
                passed_steps: passedSteps,
            }

            setProcess(newState)
        } else {
            const newState = {
                ...process,
                current_step: newStep
            }

            setProcess(newState)
        }
    };
    const handleCreateProcess = () => {
        setIsLoading({
            showLoading: true,
            loadingText: 'لطفا منتظر بمانید'
        })
        Api.post(REQUEST_URLS.ORIGINALITY_DEVICE.CREATE_PROCESS, {
            "post_token":postToken,
        }, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(response => {
            const {data, status, message, hasError} = response;

            if (hasError) {
                setIsLoading({
                    showLoading: false,
                    loadingText: 'لطفا منتظر بمانید'
                })
                handleError({
                    data, status, message, callback: () => {
                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message || 'خطای سرویس',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: 'تلاش مجدد',
                            cancelButtonTheme: 'red',
                            onCancel: () => {
                                handleCreateProcess();
                            }
                        })
                    }
                })
            } else {
                setIsLoading({
                    showLoading: true,
                    loadingText: 'در حال دریافت اطلاعات'
                })
                setPid(data.pid);
                handleGetProcess(data.pid)
            }
        }).catch(e => {

        }).finally(() => {

        })
    }
    const handleInquiryProcess = () => {
        setIsLoading({
            showLoading: true,
            loadingText: 'در حال دریافت اطلاعات'
        })
        Api.get(REQUEST_URLS.ORIGINALITY_DEVICE.INQUIRY_PROCESS, {
            params:{
                post_token:postToken,
                service_type:serviceType,
            },
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(response => {
            const {status, data, message, hasError} = response;
            if (hasError) {
                setIsLoading({
                    showLoading: false,
                    loadingText: 'در حال دریافت اطلاعات'
                });

                handleError({
                    status,
                    message,
                    data,

                    callback: () => {
                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message || 'خطای سرویس',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: 'تلاش مجدد',
                            cancelButtonTheme: 'red',
                            onCancel: () => {
                                handleInquiryProcess();
                            }
                        })
                    }
                })
            } else {
                if (data?.process && data?.process?.pid) {
                    handleGetProcess(data?.process?.pid)
                    setPid(data?.process?.pid)
                } else {
                    handleCreateProcess();
                }
            }
        }).catch((e) => {

        }).finally(() => {

        })
    }
    const handleIMEIInquiry = (newPid) => {
        setIsLoading({
            showLoading: true,
            loadingText: 'در حال استعلام '
        });
        handleGenerateUuid("IMEIInquiry", token).then(uuid => {
            Api.post(REQUEST_URLS.ORIGINALITY_DEVICE.IMEI_INQUIRY, {
                uuid: uuid,
                pid: newPid,
            }, {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }).then(response => {
                const {hasError, data, message, status} = response;
                if (hasError) {
                    setIsLoading({
                        showLoading: false,
                        loadingText: 'در حال استعلام '
                    });
                    handleError({
                        status,
                        message,
                        data,
                        callback: () => {
                            Reoverlay.showModal(ErrorModal, {
                                title: 'خطا',
                                message: message || 'خطای سرویس',
                                onConfirm: () => {
                                    Reoverlay.hideModal();
                                    if (data.can_skip) {
                                        handleSkip(newPid)
                                    } else {

                                    }
                                },
                                confirmButtonText: data.can_skip ? 'رد شدن ' : '',
                                showConfirmButton: data.can_skip ? data.can_skip : false,
                                showCancelButton: true,
                                confirmButtonTheme: "green",
                                cancelButtonText: data.can_reset ? 'ویرایش اطلاعات' : 'تلاش مجدد',
                                cancelButtonTheme: 'red',
                                pid: newPid,
                                onCancel: () => {
                                    if (data.can_reset) {
                                        handleReset(newPid);
                                    } else {
                                        handleIMEIInquiry(newPid)
                                    }

                                    Reoverlay.hideModal();

                                }
                            })
                        }
                    })
                } else {
                    handleGetProcess(newPid)
                }
            }).catch(e => {

            })
        });
    }
    const handleGetProcess = (newPid) => {
        setIsLoading({
            showLoading: true,
            loadingText: 'در حال دریافت اطلاعات'
        });

        Api.get(REQUEST_URLS.ORIGINALITY_DEVICE.FETCH_PROCESS, {
            params:{
                pid:newPid,
            },
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(response => {
            const {data, status, message, hasError} = response;
            if (hasError) {
                if (status === -10) {
                    setWarning(message)
                } else {
                    handleError({
                        status,
                        message,
                        data,
                        callback: () => {
                            Reoverlay.showModal(ErrorModal, {
                                title: 'خطا',
                                message: message || 'خطای دسترسی',
                                showConfirmButton: false,
                                showCancelButton: true,
                                cancelButtonText: 'تلاش مجدد',
                                cancelButtonTheme: 'red',
                                onConfirm: () => {
                                    Reoverlay.hideModal();
                                },
                                onCancel: () => {
                                    handleGetProcess(newPid);
                                }
                            })
                        }
                    })
                }

            } else {
                setComponents(data.components)
                setProcess(data.process);
                if (data.components.current_component.name === OriginalityDeviceDefaultSteps.SHAHKAR) {
                    handleShahkar(newPid);
                } else if (data.components.current_component.name === OriginalityDeviceDefaultSteps.IMEI_INQUIRY) {
                    handleIMEIInquiry(newPid);
                } else {
                    setIsLoading({
                        showLoading: false,
                        loadingText: 'لطفا منتظر بمانید'
                    })
                }

            }
        }).catch(e => {

        }).finally(() => {

        })
    }
    const handleSkip = (newPid) => {

        setIsLoading({
            showLoading: true,
            loadingText: 'لطفا منتظر بمانید'
        });
        Api.post(REQUEST_URLS.ORIGINALITY_DEVICE.SKIP_STEP, {
            pid: newPid,
        }, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(response => {
            const {hasError, data, message, status} = response;
            if (hasError) {
                setIsLoading(false)
                handleError({
                    status,
                    message,
                    data,
                    callback: () => {
                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message || 'خطای دسترسی',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: 'تلاش مجدد',
                            cancelButtonTheme: 'red',
                            pid: newPid,
                            onConfirm: () => {
                                Reoverlay.hideModal();
                            },
                            onCancel: () => {
                                handleSkip(newPid);
                            }
                        })
                    }
                })
            } else {
                handleGetProcess(newPid)
            }
        }).finally(() => {

        })
    }
    const handleReset = (newPid) => {
        handleLoading({
            showLoading: true,
            loadingText: 'لطفا منتظر بمانید'
        })
        Api.post(REQUEST_URLS.ORIGINALITY_DEVICE.REST_PROCESS, {
            pid: newPid,
        }, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(response => {
            const {hasError, data, message, status} = response;
            if (hasError) {
                handleLoading({
                    showLoading: false,
                    loadingText: 'لطفا منتظر بمانید'
                })
                handleError({
                    status,
                    message,
                    data,
                    callback: () => {
                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message || 'خطای دسترسی',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: 'تلاش مجدد',
                            cancelButtonTheme: 'red',
                            onConfirm: () => {
                                Reoverlay.hideModal();
                            },
                            onCancel: () => {
                                handleReset(newPid);
                                Reoverlay.hideModal();
                            }
                        })
                    }
                })
            } else {
                handleGetProcess(newPid)
            }
        }).finally(() => {

        })
    }
    const handleShahkar = (newPid) => {
        handleLoading({
            showLoading: true,
            loadingText: 'لطفا منتظر بمانید'
        })
        handleGenerateUuid('Shahkar', token).then(data => {
            handleLoading({
                showLoading: true,
                loadingText: 'لطفا منتظر بمانید'
            })
            Api.post(REQUEST_URLS.ORIGINALITY_DEVICE.SHAHKAR, {
                pid: newPid,
                uuid: data,
            }).then((response) => {
                const {data, hasError, status, message} = response;
                if (!hasError) {
                    handleGetProcess(newPid)

                } else {
                    handleLoading({
                        showLoading: false,
                        loadingText: 'لطفا منتظر بمانید'
                    })
                    handleError({
                        message,
                        status,
                        data,
                        callback: () => {
                            Reoverlay.showModal(ErrorModal, {
                                title: 'خطا',
                                message: message || 'خطای دسترسی',
                                showConfirmButton: data?.can_reset,
                                confirmButtonText: 'ویرایش اطلاعات',
                                confirmButtonTheme: "light",
                                showCancelButton: true,
                                cancelButtonText: 'تلاش مجدد',
                                cancelButtonTheme: 'red',
                                pid: newPid,
                                onConfirm: () => {
                                    if (data.can_reset) {
                                        handleReset(newPid);
                                    }
                                    Reoverlay.hideModal();
                                },
                                onCancel: () => {
                                    Reoverlay.hideModal();
                                    handleShahkar(newPid);
                                }
                            })
                        }
                    })


                }

            }).catch(() => {
                handleLoading({
                    showLoading: false,
                    loadingText: 'لطفا منتظر بمانید'
                })
            }).finally(() => {


            })

        }).catch(error => {
            console.log(error);
            handleLoading(false)
        });

    }

    const handleError = ({onConfirm, onClose, message, title, pid, data, status, options, callback}) => {
        if(status===-9){
            //rate limit
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: message,
                showCancelButton: false,
                showConfirmButton: true,
                confirmButtonText:'بازگشت به دیوار',
                confirmButtonTheme:"red",
                onConfirm:()=>{

                    handleRedirectToDivar({
                        price:null,
                        status:'fail',
                    });
                }
            })
        }else if(status===-20){
            Reoverlay.showModal(ErrorModal,{
                title:'خطا',
                message:message,
                showCancelButton:false,
                showConfirmButton:false,
            })
        }else if (status === -10) {

        } else if (status === 500) {
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: message || 'خطای سرویس',
                onConfirm: () => {
                    Reoverlay.hideModal();
                },
                showConfirmButton: false,
                showCancelButton: true,
                cancelButtonText: 'بستن',
                cancelButtonTheme: 'red',

                onCancel: () => {


                }
            })

        } else if (status === 403 || status === 401) {
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: message || 'خطای دسترسی',
                onConfirm: () => {
                    Reoverlay.hideModal();
                },
                showConfirmButton: false,
                showCancelButton: true,
                cancelButtonText: 'دریافت دسترسی ',
                cancelButtonTheme: 'red',

                onCancel: () => {
                    navigate('/auth/gate/v11dW62X4kaZ2Hn4/' + serviceType + '?post_token=' + postToken)

                }
            })
        } else if (status === 801 || status === -100 || status === 802 || status === 803 || status === 805 || status === -100) {
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: message || 'خطای دسترسی',
                onConfirm: () => {
                    Reoverlay.hideModal();
                },
                showConfirmButton: false,
                showCancelButton: true,
                cancelButtonText: 'ساخت پروسه جدید',
                cancelButtonTheme: 'red',
                onCancel: () => {
                    handleCreateProcess();
                }
            })
        } else {
            callback()
        }
    }
    const handleComponents = (newComponents) => {
        setComponents(newComponents)
    }
    if (warning) {
        return <Final message={warning}/>
    }
    return <OriginalityDeviceContext.Provider value={{
        postToken,
        isLoading,
        pid,
        token,
        process,
        components,
        handleLoading,
        handleUpdateStep,
        handleProcess,
        handleError,
        handleComponents,
        handleGetProcess,
        handleCreateProcess,
        handleSkip,
        handleReset,
        handleRedirectToDivar,

    }
    }>
        {<div className="min-h-screen">
            {isLoading && isLoading.showLoading &&
                <ProgressLoading showProgress={false} type="HamtaInquiry" duration={30}
                                 text={isLoading.loadingText || 'لطفا منتظر بمانید'} theme="green"/>}
            {!(isLoading && isLoading.showLoading) && process && components?.current_component?.name === OriginalityDeviceDefaultSteps.INIT_CONFIRM &&
                <InitConfirm/>}
            {!(isLoading && isLoading.showLoading) && process && components?.current_component?.name === OriginalityDeviceDefaultSteps.CREATE_PAYMENT &&
                <CreatePayment/>}
            {!(isLoading && isLoading.showLoading) && process && components?.current_component?.name === OriginalityDeviceDefaultSteps.PAYMENT_INQUIRY &&
                <CreatePayment/>}
            {!(isLoading && isLoading.showLoading) && process && components?.current_component?.name === OriginalityDeviceDefaultSteps.FINAL &&
                <Final/>}
        </div>}
    </OriginalityDeviceContext.Provider>
}
export default OriginalityDevice;